import {
  FormGroup, TextField,
} from '@mui/material';
import Autocomplete, {
  createFilterOptions,
} from '@mui/material/Autocomplete';
import React from 'react';
import { formatNumberPtbr } from 'utils/format-number-ptbr';

function UnitOfMeasurement({
  selectedUnity = '',
  autoCompleteOptions = [],
  error,
  helperText,
  marginTextField = 'none',
  labelTextField = 'Unidade de Medida *',
  ...rest
}) {
  const filter = createFilterOptions();

  const displayUnit = (option) => {
    if (option.multiplier) {
      return `(${formatNumberPtbr(option.multiplier)} ${option.sigla})`;
    }
    return `(${option.sigla})`;
  };

  return (
    <FormGroup>
      <Autocomplete
        {...rest}
        handleHomeEndKeys
        name="unity"
        value={selectedUnity}
        options={autoCompleteOptions}
        getOptionLabel={(option) => {
          if (typeof option === 'string') {
            return option;
          }
          if (option.inputValue) {
            return `${option.name} ${
              option.sigla ? `(${option.sigla})` : ''
            }`;
          }
          return `${option.name} ${option.sigla ? displayUnit(option) : ''}`;
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);
          return filtered;
        }}
        renderOption={(props, option) => (
          <li {...props}>
            {option.name}
            {' '}
            {option.sigla ? displayUnit(option) : ''}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={labelTextField}
            variant="outlined"
            margin={marginTextField}
            error={error}
            helperText={helperText}
          />
        )}
      />
    </FormGroup>
  );
}

export default UnitOfMeasurement;
